import { useSelector } from 'react-redux'

import { selectCockpitFinancialPlanQualitySummary } from '../selectors'

export const useCockpitFinancialPlanQuality = () =>
  useSelector(selectCockpitFinancialPlanQualitySummary).selectedQuality
